














































































import { Component, Vue } from "vue-property-decorator"
import LayoutMain from "@/components/common/LayoutMain.vue"

@Component({
	components:
	{
		LayoutMain
	}
})

export default class Frontpage extends Vue
{
}
